const FIELD_PATH = /^[A-Za-z_][A-Za-z0-9_]*(\.[A-Za-z_][A-Za-z0-9_]*)*$/;

/**
 * An AddInData `whereClause` for one field. Geotab knows a single condition only (no AND/OR) and
 * compares case-sensitively.
 */
export function whereEquals(field: string, value: string): string {
  if (!FIELD_PATH.test(field)) throw new Error(`Not a field path: ${field}`);
  const escaped = value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  return `${field} = "${escaped}"`;
}
